type PropType = { invoiceCount: number }
const InvoiceCountBadge = (props: PropType) => {
  const { invoiceCount = 0 } = props
  return (
    <div
      style={{
        background:
          'linear-gradient(90deg, rgba(185, 249, 135, 0.15) 0%, rgba(128, 240, 110, 0.15) 100%)',
      }}
      className="flex items-center justify-center px-3 ml-4"
    >
      <p className="leading-8 text-xs font-medium text-[#107715] mt-1">
        {`سابقه خرید: ${invoiceCount} بار`}
      </p>
    </div>
  )
}

export default InvoiceCountBadge
